import { render, staticRenderFns } from "./wuju-contact.vue?vue&type=template&id=2c13f3cd&scoped=true&"
import script from "./wuju-contact.vue?vue&type=script&lang=js&"
export * from "./wuju-contact.vue?vue&type=script&lang=js&"
import style0 from "./wuju-contact.vue?vue&type=style&index=0&id=2c13f3cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13f3cd",
  null
  
)

export default component.exports